"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnreadBadge = void 0;
const react_1 = __importDefault(require("react"));
const __1 = require("../../../../../..");
const Thread_styles_1 = require("../../../Thread.styles");
/**
 * Simple component that outputs a badge - text is customisable
 */
const UnreadBadge = ({ text }) => {
    return (react_1.default.createElement(Thread_styles_1.StyledUnreadBadgeContainer, null,
        react_1.default.createElement(__1.Badge, { colour: "red", luminosity: "low", theme: "ghost", text: text })));
};
exports.UnreadBadge = UnreadBadge;
//# sourceMappingURL=UnreadBadge.js.map